import React from "react"
import {Input} from "reactstrap"

const SearchBox = props => (
      <Input
        className="cta"
        type="text"
        id="searchBox"
        placeholder="Search space"
      />
    )

export default SearchBox



// WEBPACK FOOTER //
// ./src/small/SearchBox.js